// extracted by mini-css-extract-plugin
export default {"Form":"LogoutForm_Form__4j4Ob","Text":"LogoutForm_Text__XqQBJ","buttonsLogout":"LogoutForm_buttonsLogout__wdbXg"};